import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private buildTargetSubject = new BehaviorSubject<string>('');
    buildTarget$ = this.buildTargetSubject.asObservable();

    private apiUrlSubject = new BehaviorSubject<string>('');
    apiUrl$ = this.apiUrlSubject.asObservable();

    setBuildTarget(target: string) {
        this.buildTargetSubject.next(target);
    }

    getBuildTarget(): string {
        return this.buildTargetSubject.value;
    }

    setApiUrl(url: string) {
        this.apiUrlSubject.next(url);
    }

    getApiUrl(): string {
        return this.apiUrlSubject.value;
    }
} 